import { render, staticRenderFns } from "./ToCustomerSupplierSelect.vue?vue&type=template&id=0287c96e"
import script from "./ToCustomerSupplierSelect.vue?vue&type=script&lang=js"
export * from "./ToCustomerSupplierSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports